/**
 * School Log Service
 * 
 * This service handles API calls to the backend for school logs.
 * It will be used when the real backend API is available.
 */

import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import { DownloadSchoolLogQuery, SchoolLogModel, SchoolLogQuery } from "@/types/school-log.model";
import { removeEmptyProps } from "@/utils/constants";
import moment from "moment";
// Import axios when the real API is implemented
// import axios from "axios";

// Base API URL from environment variables - will be used when real API is implemented
// const API_URL = import.meta.env.VITE_API_URL || "";

/**
 * Get all school logs with pagination and filtering
 */
export const getAllSchoolLogsService = async (
  query: SchoolLogQuery // Prefixed with underscore to indicate it's intentionally unused
): Promise<{
  data: APIResponse<SchoolLogModel[]>;
}> => {
  if (query.fromDate && query.toDate) {
      query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
        "DD-MM-YYYY"
      );
      query.toDate = moment(new Date(query.toDate).toISOString()).format(
        "DD-MM-YYYY"
      );
    }
  
    return AXIOS.get<APIResponse<SchoolLogModel[]>>(
      "/auth/api/v1/sch/logs/list",
      {
        params: removeEmptyProps(query),
      }
    );
  // This will be implemented when the backend API is ready
  // For now, it will throw an error if accidentally called
  // throw new Error("Real API not implemented yet");
};

export const downloadSchoolLogService = async (
  type: "pdf" | "xl" | "csv",
  params: DownloadSchoolLogQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<{ message: string }>(
    `/auth/api/v1/sch/logs/dwnld/${type}`,
    {
      params: removeEmptyProps(params),
      responseType: "blob",
    }
  );
};

/**
 * Get a single school log by ID
 */
export const getSchoolLogService = async (
  _id: string // Prefixed with underscore to indicate it's intentionally unused
): Promise<{
  data: APIResponse<SchoolLogModel>;
}> => {
  // This will be implemented when the backend API is ready
  // For now, it will throw an error if accidentally called
  throw new Error("Real API not implemented yet");
};
